module.exports = __webpack_public_path__ + "img/IMG_6925.ae79878a.webp";